import { ActionStates } from "reactcoregk/store/actions";
import {
  createOperationState,
  getCommonState,
  handleAsyncState,
  handleCommonState,
} from "reactcoregk/store/reducer";
import {
  ADD_TABLE_SETTINGS,
  GET_ALL_TABLE_SETTINGS,
  GET_THEME_PREFERENCES,
  UPDATE_THEME_PREFERENCES,
} from "./actionTypes";
import { entityType } from "./module";

const initialState = {
  ...getCommonState(),
  tableSettings: createOperationState({}),
};

const UserSettings = (state = initialState, action) => {
  const actionEntity = action.type.split(".")[0];

  if (actionEntity !== entityType) {
    return state;
  }
  const actionType = action.type.split(".")[1];
  const actionState = action.type.split(".")[2];

  switch (actionType) {
    case GET_ALL_TABLE_SETTINGS: {
      const newState = handleAsyncState(state, action, "tableSettings");
      if (actionState === ActionStates.success) {
        return {
          ...newState,
          tableSettings: {
            ...newState.tableSettings,
            result: action.payload[0] ? action.payload[0].value : {},
          },
        };
      }
      if (newState) {
        return newState;
      }
      break;
    }
    case ADD_TABLE_SETTINGS: {
      const newState = handleAsyncState(state, action, "create");
      if (actionState === ActionStates.success) {
        return {
          ...newState,
          tableSettings: {
            ...newState.tableSettings,
            result: action.payload[0] ? action.payload[0].value : {},
          },
        };
      }
      if (newState) {
        return newState;
      }
      break;
    }
    case GET_THEME_PREFERENCES:
    case UPDATE_THEME_PREFERENCES: {
      const newState = handleAsyncState(state, action, "prefersLightMode");
      if (actionState === ActionStates.success) {
        const prefersLight = action.payload[0]
          ? action.payload[0].value
          : false;
        if (prefersLight) {
          sessionStorage.setItem("prefersLightMode", "true");
        } else {
          sessionStorage.removeItem("prefersLightMode");
        }
        return {
          ...newState,
          prefersLightMode: {
            ...newState.prefersLightMode,
            result: action.payload[0] ? action.payload[0].value : false,
          },
        };
      }
      if (newState) {
        return newState;
      }
      break;
    }
    default:
      break;
  }

  return handleCommonState(state, actionType, action, "id");
};

export default UserSettings;
